
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandW as ObiOwnShipNoCommandWElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-w.js';
 
 
 

 
 export const ObiOwnShipNoCommandW = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-w',
   elementClass: ObiOwnShipNoCommandWElement,
   events: {
     
   }
  });
 
 